// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"242":"0c8e44f5","928":"78d132d0"}[chunkId] || chunkId) + "." + {"54":"ef610969eb0698e8","242":"8109abf5e33e591b","250":"bc344bb477395366","283":"ae0894b51780a947","336":"7c6b7754e97b1057","403":"57ea0c474daf1863","563":"263f4daef25e9788","876":"e9ebd38a04cb381f","928":"a75bf8337474f028"}[chunkId] + ".js";
};